import { render, staticRenderFns } from "./TreatmentHistoryDetail.vue?vue&type=template&id=717843d4&"
import script from "./TreatmentHistoryDetail.vue?vue&type=script&lang=js&"
export * from "./TreatmentHistoryDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports